import Vue from 'vue';
import HeroSection from '@/components/HeroSection/HeroSection.vue';
import UBEmloyees from '@/components/ub-employees/ub-employees.vue';
import ImageSlideshow from '@/components/image-slideshow/image-slideshow.vue';
import CustomerRotator from '@/components/customer-rotator/customer-rotator.vue';
import PageNav from '@/components/page-nav/PageNav.vue';
var VueScrollTo = require('vue-scrollto');
var VanillaTilt = require('vanilla-tilt');
var { ScrollAnim } = require('@/directives/scroll-anim.ts');
var UbLogo = require("@/assets/svgs/ub-logo.svg");
var UbSymbols = require("@/assets/svgs/ub-symbole.svg");
var TweenMax = require("TweenMax");
var TimelineMax = require("TimelineMax");
var EasePack = require("EasePack");
var ScrollMagic = require('ScrollMagic');
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js');
export default Vue.extend({
    name: 'Home',
    components: {
        HeroSection,
        'ub-employees': UBEmloyees,
        'image-slideshow': ImageSlideshow,
        'customer-rotator': CustomerRotator,
        'ub-logo': UbLogo,
        'ub-symbols': UbSymbols,
        'page-nav': PageNav
    },
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'Ultrabold Kommunikationsdesign GmbH',
    },
    directives: {
        'scroll-to': VueScrollTo,
        'scroll-anim': ScrollAnim
    },
    data() {
        return {
            innerHeight: 0,
            scenes: {},
            distance: 500,
            sections: [
                {
                    name: 'Arbeiten',
                    id: 'arbeiten'
                },
                {
                    name: 'Leistungen',
                    id: 'leistungen'
                },
                {
                    name: 'Kompetenzen',
                    id: 'bei-ultrabold'
                },
                {
                    name: 'Kunden',
                    id: 'kunden'
                }
            ],
        };
    },
    mounted() {
        /* set innerheight */
        this.updateInnerHeight();
        window.addEventListener('resize', () => {
            this.updateInnerHeight();
        });
        /* init tilt */
        var tiltElements = document.querySelectorAll('.tilt');
        VanillaTilt.init(tiltElements, {
            reverse: true,
            transition: true,
            perspective: 1000
        });
        if (window.innerWidth > 1200) {
            this.initAnimations();
        }
        ;
    },
    methods: {
        initAnimations() {
            let welcomeScene = this.welcomeAnimation();
            let arbeitenScenes = this.arbeitenAnimation();
            let leistungenScenes = this.leistungenAnimation();
            let employeesScenes = this.employeesAnimation();
            let locationsScenes = this.locationsAnimation();
            let kundenScene = this.kundenAnimation();
            let scrollTopBtnScene = this.scrollTopBtnAnimation();
            /* merge arrays together */
            let allScenes = [];
            allScenes = allScenes.concat(welcomeScene);
            allScenes = allScenes.concat(arbeitenScenes);
            allScenes = allScenes.concat(leistungenScenes);
            allScenes = allScenes.concat(employeesScenes);
            allScenes = allScenes.concat(locationsScenes);
            allScenes = allScenes.concat(kundenScene);
            allScenes = allScenes.concat(scrollTopBtnScene);
            // init controller
            var controller = new ScrollMagic.Controller();
            controller.addScene(allScenes);
        },
        welcomeAnimation() {
            // init lineDrawTL
            let lineDrawTL = new TimelineMax();
            let lines = document.querySelectorAll('.line');
            // lines draw in
            lineDrawTL.staggerFromTo(lines, 10, {
                'height': '0%'
            }, {
                'height': '100%',
                display: 'block'
            }, 0.1, 0)
                .fromTo(lines, 1, {
                autoAlpha: 1
            }, {
                autoAlpha: 0.3
            }, 3);
            // init welcomeTimeLine
            let welcomeTL = new TimelineMax();
            // logo fade in
            welcomeTL.fromTo('.logo_area', .75, {
                'autoAlpha': 0,
                'y': -50
            }, {
                'autoAlpha': 1,
                'y': 0,
                delay: .5,
                ease: EasePack.Power0.ease
            });
            // Paragraph borders
            welcomeTL.fromTo('.border--top', 2, {
                'width': '0px',
                'autoAlpha': 0,
            }, {
                'width': '400px',
                'autoAlpha': 1,
                ease: EasePack.Power4.easeOut,
            })
                .fromTo('.border--bottom', 1.5, {
                'width': '0px',
                'autoAlpha': 0,
            }, {
                'width': '400px',
                'autoAlpha': 1,
                ease: EasePack.Power4.easeOut,
            }, '-=1.7');
            // Paragraph
            welcomeTL.fromTo('.hero_text_area p', 0.75, {
                'autoAlpha': 0,
                'x': 10
            }, {
                'autoAlpha': 1,
                'x': 0,
                ease: EasePack.Power4.ease
            }, '-=0.5');
            // image-animation fade-in
            welcomeTL.fromTo('.image-animation', 0.75, {
                'autoAlpha': 0,
            }, {
                'autoAlpha': 1,
                ease: EasePack.Power4.ease
            });
            // add label
            welcomeTL.add('claim', '+=0.25');
            // UB-Symbols draw
            let ubSymbolsSVG = document.querySelector('.ub-symbols');
            let uBSymbolsSVGChildren = ubSymbolsSVG.children;
            welcomeTL.staggerFromTo(uBSymbolsSVGChildren, 0.25, {
                'autoAlpha': 0
            }, {
                'autoAlpha': 1
            }, 0.1, 'claim')
                .to(uBSymbolsSVGChildren, 1, {
                'autoAlpha': 0.3,
                ease: EasePack.Power2.ease
            }, 'claim+=3');
            // Claim "wir gestalten marken"
            let firstWord = document.querySelector('.claim h4:first-child');
            let secondWord = document.querySelector('.claim h3');
            let thirdWord = document.querySelector('.claim h4:nth-child(3)');
            /* "WIR" */
            welcomeTL.fromTo(firstWord, .5, {
                'autoAlpha': 0,
                'y': 10
            }, {
                'autoAlpha': 1,
                'y': 0,
                ease: EasePack.Power4.ease
            }, 'claim+=0.5')
                /* "gestalten" */
                .fromTo(secondWord, .5, {
                'autoAlpha': 0,
                'y': 10
            }, {
                'autoAlpha': 1,
                'y': 0,
                ease: EasePack.Power4.ease
            }, 'claim+=1')
                /* "marken" */
                .fromTo(thirdWord, .5, {
                'autoAlpha': 0,
                'y': 10
            }, {
                'autoAlpha': 1,
                'y': 0,
                ease: EasePack.Power4.ease
            }, 'claim+=1.5');
            // main-header fade in
            welcomeTL.fromTo('.main-header', 0.75, {
                'autoAlpha': 0,
                'y': -50
            }, {
                'autoAlpha': 1,
                'y': 0,
                ease: EasePack.Power4.ease
            }, 'claim');
            // continue button
            let BtnContinue = document.getElementsByClassName('continue');
            welcomeTL
                .fromTo(BtnContinue, .5, {
                'autoAlpha': 0,
                'y': 10,
            }, {
                'autoAlpha': 1,
                'y': 0,
                ease: EasePack.Power4.ease
            }, 'claim')
                .timeScale(2)
                .play();
            /*************************** */
            /********** PARALLAX *********/
            /*************************** */
            // init timeline
            let parallaxTL = new TimelineMax();
            // TWEEN: Claim
            parallaxTL
                .to(firstWord, 0.5, {
                'y': -1000,
                ease: EasePack.Circ.easeIn,
            }, 0)
                .to(secondWord, 0.5, {
                'y': -750,
                ease: EasePack.Circ.easeIn,
            }, 0.1)
                .to(thirdWord, 0.5, {
                'y': -500,
                ease: EasePack.Circ.easeIn,
            }, 0.2);
            // TWEEN: UB-Symbole
            for (var i = uBSymbolsSVGChildren.length; i >= 0; i--) {
                ubSymbolsSVG.appendChild(ubSymbolsSVG.children[Math.random() * i | 0]);
            }
            for (var i = uBSymbolsSVGChildren.length; i >= 1; i--) {
                parallaxTL.to(ubSymbolsSVG.children[i - 1], 0.5, {
                    'y': Math.random() * -5000,
                }, i * 0.1);
            }
            parallaxTL
                .to(ubSymbolsSVG, 2, {
                'y': -1000,
                ease: EasePack.Circ.easeIn
            }, 0);
            // create a scene
            const welcomeScene = new ScrollMagic.Scene({
                triggerHook: 0,
                duration: this.innerHeight * 2,
            })
                .setTween(parallaxTL);
            /* RETURN SCENES */
            return [welcomeScene];
        },
        arbeitenAnimation() {
            /*************************** */
            /********** Greensock *********/
            /*************************** */
            //  DOM-ELEMENTS
            let arbeiten = document.getElementById('arbeiten');
            // init timeline
            let arbeitenTL = new TimelineMax();
            // #app fade in
            arbeitenTL.fromTo('#arbeiten .row', 0.75, {
                'autoAlpha': 0,
                'y': 150
            }, {
                'autoAlpha': 1,
                'y': 0,
                clearProps: 'all'
            }, 0);
            /*************************** */
            /********** Scrollmagic *********/
            /*************************** */
            // create a scene
            const arbeitenFadeInScene = new ScrollMagic.Scene({
                triggerElement: arbeiten,
                triggerHook: 0.45,
                duration: this.innerHeight,
            })
                .setTween(arbeitenTL);
            /*************************** */
            /********** Parallax *********/
            /*************************** */
            // init timeline
            let arbeitenParallaxTL = new TimelineMax();
            arbeitenParallaxTL
                .fromTo('#arbeiten .section-title', 1, {
                'y': 105
            }, {
                'y': 0,
            }, 0)
                .fromTo('#arbeiten .works_content-image-1', 1, {
                'bottom': -100,
            }, {
                'bottom': 0,
                'position': 'relative'
            }, 0)
                .fromTo('#arbeiten .works_content-image-2', 1, {
                'top': 25,
                'left': 25
            }, {
                'left': 0,
                'bottom': 0,
                'position': 'relative'
            }, 0)
                .fromTo('#arbeiten .btn', 1, {
                'y': 125
            }, {
                'y': -125
            }, 0);
            /*************************** */
            /********** Scrollmagic *********/
            /*************************** */
            // create a scene
            const arbeitenParallax = new ScrollMagic.Scene({
                triggerElement: arbeiten,
                triggerHook: 0.45,
                duration: this.innerHeight * 2,
            })
                .setTween(arbeitenParallaxTL);
            /* return scenes */
            return [arbeitenFadeInScene, arbeitenParallax];
        },
        leistungenAnimation() {
            /*************************** */
            /********** Greensock *********/
            /*************************** */
            //  DOM-ELEMENTS
            let leistungen = document.getElementById('leistungen');
            // init timeline
            let leistungenTL = new TimelineMax();
            // #app fade in
            leistungenTL.fromTo('#leistungen .row', 0.75, {
                'autoAlpha': 0,
                'y': 50
            }, {
                'autoAlpha': 1,
                'y': 0,
            }, 0);
            /*************************** */
            /********** Scrollmagic *********/
            /*************************** */
            // create a scene
            const leistungenFadeInScene = new ScrollMagic.Scene({
                triggerElement: leistungen,
                triggerHook: 0.5,
                duration: this.innerHeight / 2,
            })
                .setTween(leistungenTL);
            /* return scenes */
            return [leistungenFadeInScene];
        },
        employeesAnimation() {
            /*************************** */
            /********** Greensock *********/
            /*************************** */
            // init timeline
            let employeesTL = new TimelineMax();
            // #app fade in
            employeesTL.fromTo('.employee-skill-area .row', 0.75, {
                'autoAlpha': 0,
            }, {
                'autoAlpha': 1,
            }, 0)
                .to('.image-animation', 0.75, {
                'autoAlpha': 0
            });
            /*************************** */
            /********** Scrollmagic *********/
            /*************************** */
            // create a scene
            const employeesScene = new ScrollMagic.Scene({
                triggerElement: '.employee-skill-area',
                triggerHook: 0.5,
                duration: this.innerHeight,
            })
                .setTween(employeesTL);
            /* return scenes */
            return [employeesScene];
        },
        locationsAnimation() {
            /*************************** */
            /********** Greensock *********/
            /*************************** */
            //  DOM-ELEMENTS
            let locationArea = document.querySelector('.location-area');
            // init timeline
            let locationAreaTL = new TimelineMax();
            // #app fade in
            locationAreaTL.fromTo('.location-area .hero-section', 0.75, {
                'autoAlpha': 0
            }, {
                'autoAlpha': 1
            }, 0);
            /*************************** */
            /********** Scrollmagic *********/
            /*************************** */
            // create a scene
            const locationAreaScene = new ScrollMagic.Scene({
                triggerElement: locationArea,
                triggerHook: 0.5,
                duration: this.innerHeight,
            })
                .setTween(locationAreaTL);
            /* return scenes */
            return [locationAreaScene];
        },
        kundenAnimation() {
            /*************************** */
            /********** Greensock *********/
            /*************************** */
            // init timeline
            let kundenTL = new TimelineMax();
            // #kunden fade in
            kundenTL.fromTo('#kunden .row', 0.75, {
                'autoAlpha': 0,
                'y': 100
            }, {
                'autoAlpha': 1,
                'y': 0
            }, 0);
            /*************************** */
            /********** Scrollmagic *********/
            /*************************** */
            // create a scene
            const kundenScene = new ScrollMagic.Scene({
                triggerElement: '#kunden',
                triggerHook: 0.8,
                duration: this.innerHeight * 1.5,
            })
                .setTween(kundenTL);
            /* return scenes */
            return [kundenScene];
        },
        scrollTopBtnAnimation() {
            /*************************** */
            /********** Greensock *********/
            /*************************** */
            // init timeline
            let scrollTopBtnTL = new TimelineMax();
            // scroll top btn
            scrollTopBtnTL.fromTo('.scroll-top-btn .icon', 0.75, {
                rotation: 90,
            }, {
                rotation: -90,
            }, 0);
            /*************************** */
            /********** Scrollmagic *********/
            /*************************** */
            // create a scene
            const scrollTopBtnScene = new ScrollMagic.Scene({
                triggerElement: '.scroll-top-btn',
                triggerHook: 0.9,
                duration: 200,
            })
                .setTween(scrollTopBtnTL);
            /* return scenes */
            return [scrollTopBtnScene];
        },
        updateInnerHeight() {
            this.innerHeight = window.innerHeight;
        },
        calculateDistance(e) {
            let mouseX = e.pageX;
            let mouseY = e.pageY;
            let elem = document.getElementsByClassName('continue-wrapper')[0];
            let rect = elem.getBoundingClientRect();
            let topPosition = rect.top + window.pageYOffset;
            let leftPosition = rect.left;
            let width = elem.clientWidth;
            let height = elem.clientHeight;
            this.distance = Math.floor(Math.sqrt(Math.pow(mouseX - (leftPosition + (width / 2)), 2) + Math.pow(mouseY - (topPosition + (height / 2)), 2)));
        }
    },
    computed: {
        distanceOffset() {
            if (this.distance <= 447 && this.distance >= 41) {
                let el = document.getElementsByClassName('triangle_down')[0];
                //@ts-ignore
                el.style.transition = '';
                return (this.distance);
            }
            else if (this.distance <= 40) {
                let el = document.getElementsByClassName('triangle_down')[0];
                //@ts-ignore
                el.style.transition = 'transform .1s linear';
                return 0;
            }
            else {
                return 447;
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/views/Home/Home.ts
// module id = null
// module chunks = 